/* eslint-disable */

export default {
  "signup": {
    "title": "S'inscrire",
    "subtitle": "ou vous connecter à votre compte",
    "tos": "J'accepte les conditions de service de RELE.AI",
    "privacy": "J'accepte les conditions de confidentialité de RELE.AI",
    "chooseMethod": "Créez votre compte",
    "provideNumberDescription": "Bonjour 👋<br />Veuillez fournir votre numéro de portable afin de vous permettre d'accéder à RELE.AI, votre assistante CRM.",
    "createOrganizationDescription": "Veuillez nommer votre entreprise.<br />Une fois créé, vous pourrez connecter votre CRM et inviter les membres de votre équipe.",
    "firstIntegrationDescription": "Connectez RELE.AI avec l'une des intégrations ci-dessous. Vous pouvez toujours la modifier ou ajouter d'autres intégrations plus tard sur la page des intégrations."
  },
  "globals": {
    "search": "Rechercher...",
    "hi": "Bonjour",
    "contactClara": "Contacter RELE.AI",
    "page": "Page",
    "month": "Mois",
    "year": "Année"
  },
  "payments": {
    "yearly": "Plans annuels",
    "monthly": "Plans mensuels",
    "small": "Petit",
    "enterprise": "Entreprise",
    "smallDescription": "Petites ou moyennes entreprises ? Ce plan est désigné pour maximum 100 utilisateurs",
    "enterpriseDescription": "Vous avez plus de 100 utilisateurs ?",
    "planLayout_monthly": "utilisateur/mois",
    "planLayout_yearly": "utilisateur/année",
    "welcome": "Nous sommes très heureux de vous avoir avec nous ! 🥳<br /><br />Si vous avez besoin d'aide, n'hésitez pas à nous contacter à <a href='mailto:support@rele.ai' class='text-r-primary'>support@rele.ai</a>",
    "errorOnCheckout": "Quelque chose s'est mal passé mailto:support@rele.ai<br /><br />Nous serons ravis de vous aider, il suffit de nous envoyer un e-mail à <a href='support@rele.ai' class='text-r-primary'>😕</a>",
    "activeSubscription": {
      "dialogs": {
        "update": {
          "title": "Changement du plan d'abonnement",
          "description": "RELE.AI propose des plans mensuels et annuels qui peuvent être consultés sur notre <a href=\"https://rele.ai/pricing/\" target=\"_blank\" about class=\"text-r-primary\">page des prix.</a><br />Si vous souhaitez passer d'un plan à l'autre, il vous suffit de sélectionner le plan souhaité dans le menu déroulant et de cliquer sur \"Save\".",
          "plans": "Plans"
        },
        "delete": {
          "title": "Annuler l'abonnement",
          "description": "<div class=\"font-semibold\">Nous ne voulons pas que vous alliez sur 😢</div><br />Etes-vous sûr de vouloir annuler votre abonnement ? <br />Parlons d'abord <a href='mailto:support@rele.ai' class=\"text-r-primary\">support@rele.ai</a>"
        }
      },
      "invoices": {
        "title": "Factures",
        "created": "Date de la facture",
        "amountPaid": "Montant payé",
        "invoicePdf": "Télécharger la facture",
        "emptyItems": "Pas encore de factures"
      },
      "subscriptionInfo": {
        "title": "Détails de l'abonnement",
        "startDate": "Date de début",
        "plan": "Plan",
        "price": "{amount} {currency}/Utilisateur/{interval}",
        "amountOfUsers": "Nombre d'utilisateurs"
      }
    }
  },
  "usersManagement": {
    "user": "Utilisateur",
    "table": {
      "name": "Nom de l'employé",
      "email": "Adresse électronique",
      "phone": "Numéro de téléphone portable",
      "actions": "Actions",
      "title": "Gestion des utilisateurs",
      "addNew": "Ajouter un utilisateur"
    },
    "deleteDialog": {
      "title": "Supprimer un utilisateur",
      "description": "Êtes-vous sûr de vouloir supprimer {name} ?"
    }
  },
  "activeIntegrations": {
    "integration": "Intégration",
    "table": {
      "title": "Intégrations actives",
      "noIntegrations": "Oups ! Vous n'avez pas d'intégration active. Veuillez activer l'une des intégrations et commencer à documenter."
    }
  },
  "nonActiveIntegrations": {
    "title": "Marché",
    "description": "Pour activer l'une des intégrations ci-dessous, cliquez sur la carte d'intégration et suivez les instructions.",
    "hubspot": {
      "title": "Intégration Hubspot",
      "description": "Intégrez votre compte CRM Hubspot et lancez le document."
    },
    "salesforce": {
      "title": "Intégration de  Salesforce",
      "description": "Intégrez votre compte Salesforce CRM et lancez le document."
    },
    "mailing": {
      "title": "Intégration du courriel",
      "description": "Intégrez votre compte Mail et lancez le document."
    },
    "noIntegrations": "Félicitations ! <br /> Vous avez activé toutes les intégrations."
  },
  "integrations": {
    "table": {
      "title": "Intégrations"
    },
    "crm": {
      "giveCarlaAccess": "Pour connecter RELE.AI, veuillez suivre les étapes suivantes",
      "title": "Intégrations CRM",
      "noCrmConnections": "Vous n'avez toujours pas fourni à RELE.AI l'accès à votre CRM.",
      "connectCrm": "Connecter le CRM",
      "apiKey": "Clé API :",
      "updateConnection": "Modifier",
      "selectCRM": "Sélectionnez un CRM",
      "salesforce": {
        "guide": "<ol class=\"list-decimal\"><li>Connectez-vous à Salesforce en cliquant sur le bouton ci-dessous</li><li>Approuvez l'accès à RELE.AI</li></ol>.",
        "releaiPackage": "<div>• Avant de vous connecter à Salesforce, vous devez associer votre compte Salesforce à l'application RELE.AI Salesforce.<br /><div style='margin-top: 10px;'>• Veuillez vérifier auprès de votre administrateur Salesforce que l'application est déjà installée. S'il n'est pas installé, vous pouvez le faire en cliquant <a style='color: blue;' href=\"https://login.salesforce.com/packaging/installPackage.apexp?p0=04t3z000001zs7p\" target=\"_blank\">ici</a>.</div><div style='margin-top: 10px;'>• Pour plus d'informations: <a style='color: blue;' href=\"https://rele.ai/how-to-connect-salesforce/\" target=\"_blank\">https://rele.ai/how-to-connect-salesforce</a></div></div>"
      },
      "hubspot": {
        "chooseAuth": {
          "oauth": "Connectez-vous avec Hubspot",
          "apiKey": "Clé API",
          "title": "Choisissez la méthode authentifiée",
          "description": "Veuillez sélectionner votre connexion au hubspot. Vous pouvez choisir de vous connecter en utilisant la clé API de votre compte de hubspot, ou en utilisant la connexion OAuth."
        },
        "guideOauth": "<ol class=\"list-decimal\"><li>Connectez-vous au Hubspot en cliquant sur le bouton ci-dessous</li><li>Approuver l'accès à RELE.AI</li></ol>.",
        "guideApiKey": "<ol class=\"list-decimal\"><li>Connectez-vous à votre compte HubSpot</li><li>Accédez aux paramètres du HubSpot en cliquant sur votre Profil -> Profil & préférences</li><li>Dans le menu de gauche, allez à Intégrations -> Clé API</li><li>Copiez la clé API et collez-la dans l'entrée ci-dessous</li></ol>.",
        "docs": {
          "part1": "Vous ne l'avez pas trouvé ? Veuillez consulter le site",
          "link": "ce",
          "part2": "lien pour plus d'explications"
        }
      },
      "deleteDialog": {
        "title": "Supprimer l'intégration",
        "description": "Êtes-vous sûr de vouloir supprimer l'intégration de {name} ?"
      }
    },
    "mailing": {
      "guide": "Autorisez l'accès pour l'envoi de courriels en cliquant sur la case à cocher.",
      "checkbox": {
        "enable": "Le courriel est activé.",
        "disable": "Le courriel est désactivé.",
        "disableInfo": "Veuillez ajouter une adresse électronique à votre compte avant d'activer le courriel"
      }
    }
  },
  "notifications": {
    "trailEndIn": "Votre essai se termine {jours}. Veuillez compléter les informations relatives à votre paiement. 🤑",
    "editSuccess": "Félicitations ! Vous venez de mettre à jour {name}.",
    "createSuccess": "Félicitations ! Vous venez de créer {name}."
  },
  "forms": {
    "firstname": "Prénom",
    "lastname": "Nom de famille",
    "email": "Adresse courriel",
    "mobile": "Numéro de téléphone portable",
    "workspace": "Nom de l'entreprise",
    "botLang": "Langue préférée du bot",
    "claraNumber": "Numéro de bot préféré",
    "password": "Mot de passe"
  },
  "buttons": {
    "continueWithGoogle": "Continuer avec Google",
    "continueWithMicrosoft": "Continuer avec Microsoft",
    "next": "Suivant",
    "back": "Retour",
    "getStarted": "Suivant",
    "edit": "Edit",
    "save": "Sauvegarder",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "signOut": "Déconnexion",
    "continueWithSalesforce": "Poursuivre avec Salesforce",
    "continueWithHusbpot": "Continuer avec Hubspot",
    "botSettings": "Paramètres des robots",
    "consoleSettings": "Paramètres des Console",
    "close": "Fermer",
    "continueWithEmail": "Continuer avec le courriel",
    "cancelSubscription": "Annuler l'abonnement",
    "changePlan": "Changement du plan",
    "deleteCompany": "supprimer l'entreprise"
  },
  "errors": {
    "unableToAuthenticateTitle": "Impossible de compléter l'authentification",
    "missingRequiredField": "Champs obligatoires manquants",
    "unableToCreateUser": "Impossible de créer un utilisateur",
    "workspaceNameRequired": "Le nom de l'espace de travail est requis",
    "unableToCreateNewOrg": "Impossibilité de créer une entreprise",
    "unableToUpdateUserWithOrgId": "Impossible de rattacher l'utilisateur à l'entreprise",
    "validateEmail": "Courriel non valable. Veuillez entrer une adresse électronique valable.",
    "validateFirstName": "Prénom non valable. N'entrez pas d'espaces ou de caractères spéciaux.",
    "validateLastName": "Nom de famille non valable. N'entrez pas de caractères spéciaux à côté de \"-\".",
    "unableToDeleteUser": "Impossible de supprimer l'utilisateur",
    "unableToLoginWithSalesforce": "Impossible de se connecter avec Salesforce.",
    "unableToLoginWithHubspot": "Impossible de se connecter avec Husbpot.",
    "unableToEnableMailing": "Impossible d'intégrer le courriel",
    "unableToCreatePaymentSubscription": "Impossibilité d'effectuer un paiement.",
    "unableToDeleteIntegration": "Impossible de supprimer l'intégration.",
    "unableToSaveBotSettings": "Impossible de sauvegarder les paramètres du robot.",
    "unableToChangeSubscription": "Impossible de changer le plan d'abonnement.",
    "unableToCancelSubscription": "Impossible d'annuler l'abonnement. Veuillez contacter notre équipe d'assistance.",
    "validateMobile": "Il y a un utilisateur existant avec le même numéro."
  },
  "placeholders": {
    "enterYourEmail": "Entrez votre courriel",
    "enterYourPassword": "Entrez votre mot de passe"
  },
  "botOptions": {
    "inherit": "Langue de l'entreprise par défaut",
    "en": "Anglais",
    "es": "Espagnol",
    "fr": "Français",
    "gr": "Allemand",
    "pt": "Portugais"
  },
  "botSettings": {
    "title": "Paramètres du robot"
  },
  "deleteCompany.title": "supprimer l'entreprise"
}